import { motion } from "framer-motion";
import { Home, RefreshCcw, Globe2, Banknote, HeartPulse, ShieldCheck, ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n";

const ICONS = [Home, RefreshCcw, Globe2, Banknote, HeartPulse, ShieldCheck];

const Services = () => {
  const { t, lang } = useI18n();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <div className="text-xs tracking-[0.25em] uppercase text-[#A60056] font-semibold mb-4">
            {lang === "pt" ? "Serviços" : "Services"}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white mb-5 text-balance">
            {t.services.title}
          </h2>
          <p className="text-white/60 text-base sm:text-lg">{t.services.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.a
                key={s.t}
                href="#contact"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                whileHover={{ y: -4 }}
                className="group relative p-7 md:p-8 rounded-2xl glass overflow-hidden cursor-pointer"
                data-testid={`service-card-${i}`}
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-[#A60056]/10 via-transparent to-transparent" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-[#A60056]/15 border border-[#A60056]/25 mb-6">
                    <Icon className="w-5 h-5 text-[#A60056]" strokeWidth={1.8} />
                  </div>
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <h3 className="text-xl md:text-2xl text-white font-medium tracking-tight whitespace-pre-line leading-tight">
                      {s.t}
                    </h3>
                    <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-white group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  </div>
                  <p className="text-white/55 leading-relaxed text-[15px]">{s.d}</p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
